export enum InternalLinkType {
  BodyStyle = 'bodyStyles',
  PopularMakesModels = 'popularMakesModels',
  TopLocations = 'topLocations'
}
